<template>
    <div>
        <div class="area-list-item"
            v-if="historyController.isLoaded && historyController.isHaveItem">
            <ListItem
                v-for="(item, index) in historyController.list"
                :key="index"
                :item="item"
                :itemIndex="index"
                :lbl="lbl"
                :historyController="historyController"
                :modalController="modalController" />
        </div>
        <div class="area-list-item"
            v-if="historyController.isLoaded && !historyController.isHaveItem">
            <div class="empty-area-list"
                :class="[{'empty-mass': theme == 'mass'}, {'empty-prestige': theme == 'prestige'}]">
                <img class="empty-area-img"
                    src="../asset/ic-coupon@3x.png"
                    v-if="theme == 'mass'" />
                <img class="empty-area-img"
                    src="../asset/ic-coupon-prestige.svg"
                    v-if="theme == 'prestige'" />
                <div id="empty_area_name">
                    {{lbl.history.empty_list}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ListItem from "./ListItem.vue";
export default {
    name: "HistoryList",
    components: {
        ListItem,
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        lbl: Object,
        historyController: Object,
        modalController: Object
    },
    mounted: function () {
        this.initialLoadMore();
    },
    methods: {
        initialLoadMore: function () {
            window.onscroll = () => {
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow)
                    this.historyController.loadMore();

            };
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.area-list-item {
    padding: {
        top: 23px;
        bottom: 30px;
        left: 25px;
        right: 25px;
    };
}

.empty-area-list {
    height: 70vh;
    padding: {
        top: 70px;
    };

    .empty-area-img {
        display: block;
        width: 75px;
        margin: auto;
    }

    #empty_area_name {
        margin-top: 17px;
        //font
        font-size: 1.125rem;
        // font-family: $body_bold;
        // line-height: 1;
        text-align: center;
    }

    &.empty-mass {
        #empty_area_name {
            color: #adb0b5;
        }
    }

    &.empty-prestige {
        #empty_area_name {
            color: $prestige_theme_color;
            opacity: 0.5;
        }
    }
}
</style>
